module.exports = __webpack_public_path__ + "static/media/roar2.9e6e1080.mp3";